import React, { useEffect, useRef, useState } from "react";
import { Card, Space, AutoComplete, Button, notification  } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";

import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { BsCartPlus } from "react-icons/bs";
import { useCart } from 'react-use-cart';
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import { MdDoNotDisturbAlt, MdCheckCircle } from "react-icons/md";
import { NotificationAddCartSuccess, NumberFormatter } from "../../Helper/ECatalogHelper";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useUserContext } from "../../Context/UserContext";
import { DeleteFavoriteItem, InsertFavoriteItem } from "../../Services/EcatalogService";
import EmployeeDialog from "../DataFechDialogComponents/EmployeeDialog/EmployeeDialog";

const { Meta } = Card;

interface Props {
    product: IProductItem,
    width?: string,
    ShowQuantity?: boolean,
    CanEdit?: boolean,
    FavoriteCallback: (data: any) => void;
}

// const handleItemClick = (event: any) => {
//     const div = event.currentTarget;
//     const edit = div.querySelector('.product-item-quantity');
//     if (edit === event.target) {
//         return;
//     }
//     return this.handleItemClick();
// }

export default  function ProductItem ({product, width = "230px", ShowQuantity = false, FavoriteCallback}: Props) {
    const {
        isEmpty,
        totalUniqueItems,
        items,
        updateItemQuantity,
        removeItem,
        totalItems,
        addItem
    } = useCart();
    const [userData, setUserData] = useUserContext();
    const history = useHistory();
    const [productqty, setProductqty] = useState<number>(1);
    const [isFavorite, setIsFavorite] = useState<boolean>(product.isFavorite)
    //console.log("fav", product.isFavorite);
    const updateQuantity = (isAdd: boolean) => {
        var currentQty = productqty;
        if (isAdd)
            currentQty = currentQty + 1;
        else
            currentQty = currentQty != 1 ? currentQty - 1 : currentQty;
        setProductqty(currentQty);
    }
    const addToCart = () => {

        addItem(product, productqty);
        setProductqty(1);
        NotificationAddCartSuccess();
        //history.push(`/cart`);
    }

    const updateFavoriteItem = async () => {
        let currentFav = isFavorite;
        setIsFavorite(!isFavorite);
        let jsondata = {
            EmployeeId: userData.EmployeeId,
            ItemID: product.itemId
        }
        if (currentFav){
            await DeleteFavoriteItem(jsondata);
        }
            
        else{
            await InsertFavoriteItem(jsondata);
        }

        FavoriteCallback(jsondata);
    }
    
 
    return (
        <Card className="product-item-card" key={product.id}
                           hoverable
                           style={{ width: width }}
                           cover={
                            <img alt={product.title} src={product.defaultthumbnail} 
                            style={{width: "50%", display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "5px" }}   />
                        }
                        onClick={(event) => {
                            //event.stopPropagation();
                            const div = event.currentTarget;
                            const edit = div.querySelector('.product-item-quantity');
                            if (event.target.className === "product-qty-btn txtInput") {
                                return ;//history.push(`/productdetail?productid=${product.id}`, product.id);
                            }
                            history.push({
                                pathname: "/productdetail",
                                search: `?productid=${product.itemId}`,
                                state: { fromPopup: true }
                              });

                            //history.push(`/productdetail?productid=${product.itemId}`, product.itemId);
                            //return history.push(`/productdetail?productid=${product.id}`, product.id);
                        }}
                           //onClick={() => { history.push(`/productdetail?productid=${product.id}`, product.id); } }
                        //    actions={[
                        //     <Button type="primary" htmlType="button" className="product-action-addcart-button" icon={<BsCartPlus style={{width: "20px", height: "20px", marginRight: "10px"}}
                        //         onClick={() => { addToCart(product); }} />}>
                        //         เพิ่มไปยังรถเข็น
                        //     </Button>
                        //        ]}
                       >
                          
                           {/* <Meta title={product.title} description={product.description} >
                           <p className='mt-2 text-gray-600'>${product.price}</p>

                           </Meta> */}
                            <Meta title={product.title} description={
                                    <>
                                    {/* <div className="mt-2 text-gray-600 text-sm">รหัสสินค้า {product.itemId}</div>
                                    
                                    {
                                        ShowQuantity && (
                                            <div className="text-gray-600 text-sm">
                                            {
                                                product.itemStock > 0 ? (
                                                    <>
                                                        <div className="product-item-have-stock"><MdCheckCircle/> สินค้าพร้อมส่ง</div>
                                                        <div>เหลือ { product.itemStock } { product.itemUnit}</div>
                                                    </>
                                                ) : (
                                                    <>
                                                    <div className="product-item-no-stock"><MdDoNotDisturbAlt/> สินค้าหมดชั่วคราว</div>
                                                </>
                                                )
                                            }
                                        </div>
                                        )

                                    } */}
                                    
                                    
                                    {/* <div className='mt-2 text-gray-600 text-sm'>{product.description?.slice(0, 40)}...</div> */}
                                    <div className="mt-2 text-gray-600 text-sm">ราคาต่อหน่วย</div>
                                    <div className='text-gray-600 product-item-price'>
                                        {/* ฿ {product.price.toFixed(2)} */}
                                        { NumberFormatter(product.price) } บาท
                                    </div>
                                    
                                    
                                    {
                                        ShowQuantity && (
                                         /*product.itemStock > 0 ? (*/
                                            
                                                <div className="product-item-quantity">
                                                        <div style={{display: "flex", justifyContent: "flex-start"}}>
                                                        <section style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
                                                
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <button className="product-qty-btn btnDecrease" onClick={(event) => { event.stopPropagation(); updateQuantity(false); }}>-</button>
                                                                <input key={product.id} className="product-qty-btn txtInput" type="number" min={1} role="spinbutton" aria-live="assertive" defaultValue={productqty} value={productqty} onKeyPress={(event) => {event.stopPropagation();}}
                                                                onChange={e => {
                                                                    if (e.target.value != "" && e.target.value != "0" && e.target.value.indexOf('-') < 0){
                                                                        setProductqty(parseInt(e.target.value))
                                                                    }
                                                                    else
                                                                    {
                                                                        setProductqty(1)
                                                                    }
                                                                   }} 
                                                                ></input>
                                                                <button className="product-qty-btn btnIncrease" onClick={(event) => { event.stopPropagation(); updateQuantity(true); }}>+</button>
                                                            </div>
                                                        </section>
                                                        <button className="product-item-buy-btn" onClick={(event) => { event.stopPropagation(); addToCart();}}>เพิ่มลงตะกร้า</button>
                                                        {/* <button className="product-item-fav-btn" onClick={(event) => { event.stopPropagation(); updateFavoriteItem(); }} >   
                                                            {
                                                                isFavorite ? <FaHeart/>  : <FaRegHeart />
                                                            }
                                                        </button> */}
                                                        </div>
                                                   
                                            </div>
                                            
                                         /*) : (<div style={{ minHeight: "25px"}}></div>)*/

                                        )
                                    }
                                    
                                </>

                            } style={{display: "block"}}  >
                          

                           </Meta>                           
                       </Card>

    )
}

